import { Reducer } from 'react';
import { BidPanelActionEnum, BidPanelActions, IBidPanelState } from '.';
import { BidProductTypeEnum, BidStatus, IAuction, IBidItem, IBidResult, IBook, IItaAuctionResult, ICapacityReturn } from '../../services';
import { getNewBid } from './ActionCreator';

const sampleAuction: IAuction = {
  id: 1,
  auctionName: 'IF2-GB-FR-D-DAILY--230511-01',
  bidStatus: '',
  bidResult: {
  documentId: '',
  status: '',
  errors: [],
  bids: [] as IBidItem[]
  } as IBidResult,
  successfullyBidResult: {
    documentId: '',
    status: '',
    errors: [],
    bids: [] as IBidItem[]
    } as IBidResult,
    hasSuccessfullyBid: false,
    books: [] as IBook[],
  corridor: 'IF2-GB-FR',
  ftroption: 'PTR',
  identification: "IF2-GB-FR-D-DAILY--230511-01",
  product: "Daily",
  biddingOpen: new Date(), //"2023-05-10T07:40:00+00:00",
  biddingClose: new Date(), //"2023-05-20T22:59:59+00:00",
  isBidGateOpen: true,
  maintenances: [],
  productResults: [],
  productDetails: [
    {
      "corridorCode": "IF2-GB-FR",
      "offeredCapacity": 1034,
      "productHour": "00:00-01:00",
      "productType": BidProductTypeEnum.Daily

      
    },
    {
      "corridorCode": "IF2-GB-FR",
      "offeredCapacity": 1034,
      "productType": BidProductTypeEnum.Daily,

      "productHour": "01:00-02:00",
      
      
    },
    {

      "corridorCode": "IF2-GB-FR",
      "productType": BidProductTypeEnum.Daily,

      "offeredCapacity": 1154,
      
      
      "productHour": "02:00-03:00",
      
      
    },
    {
      "corridorCode": "IF2-GB-FR",
      "offeredCapacity": 1154,
      
      "productHour": "03:00-04:00",
      "productType": BidProductTypeEnum.Daily

      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1154,
      
      
      "productHour": "04:00-05:00",
      "productType": BidProductTypeEnum.Daily

      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1154,
      
      
      "productHour": "05:00-06:00",
      "productType": BidProductTypeEnum.Daily

      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1039,
      
      "productHour": "06:00-07:00",
      "productType": BidProductTypeEnum.Daily

      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1039,
      
      "productHour": "07:00-08:00",
      "productType": BidProductTypeEnum.Daily

      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1039,
      
      "productHour": "08:00-09:00",
      "productType": BidProductTypeEnum.Daily

    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1154,
      "productHour": "09:00-10:00",
      "productType": BidProductTypeEnum.Daily

      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1154,
      "productHour": "10:00-11:00",
      "productType": BidProductTypeEnum.Daily

      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1154,
      "productHour": "11:00-12:00",
      "productType": BidProductTypeEnum.Daily

      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1154,
      "productHour": "12:00-13:00",
      "productType": BidProductTypeEnum.Daily

      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1154,
      "productHour": "13:00-14:00",
      "productType": BidProductTypeEnum.Daily

      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1154,
      "productHour": "14:00-15:00",
      "productType": BidProductTypeEnum.Daily

      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1154,
      "productHour": "15:00-16:00",
      "productType": BidProductTypeEnum.Daily

      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1154,
      "productHour": "16:00-17:00",
      "productType": BidProductTypeEnum.Daily

      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1154,
      "productHour": "17:00-18:00",
      "productType": BidProductTypeEnum.Daily

      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1154,
      "productHour": "18:00-19:00",
      "productType": BidProductTypeEnum.Daily
      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1154,
      "productHour": "19:00-20:00",
      "productType": BidProductTypeEnum.Daily
      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1154,
      "productHour": "20:00-21:00",
      "productType": BidProductTypeEnum.Daily
      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1154,
      "productHour": "21:00-22:00",
      "productType": BidProductTypeEnum.Daily
      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1154,
      "productHour": "22:00-23:00",
      "productType": BidProductTypeEnum.Daily
      
    },
    {

      "corridorCode": "IF2-GB-FR",

      "offeredCapacity": 1034,
      "productHour": "23:00-24:00",
      "productType": BidProductTypeEnum.Daily
      
    }
  ],
  "lastDataUpdate": new Date(), //"2023-05-10T13:18:52.9933333+00:00",
  "cancelled": false,
  "periodStart": new Date(), //"2023-05-10T22:00:00+00:00",
  "periodStop": new Date(), //"2023-05-11T22:00:00+00:00",
  "exchangeCode":'JAO',
  "exchangeId": 1,
  auctionResultStatus: "Auction Open",
  auctionResult: {} as IItaAuctionResult,
  capacityReturn: {} as ICapacityReturn,
  capacityReturnGateOpen: new Date("2023-05-10T21:00:00+00:00"),
  capacityReturnGateClose: new Date("2023-05-11T21:00:00+00:00"),
}


export const initialBidPanelState: IBidPanelState = {
  showBidPanel: false,
  loading: false,
  newBlankBid: getNewBid(sampleAuction),
};

export const bidPanelReducer: Reducer<IBidPanelState, BidPanelActions> = (
  state = initialBidPanelState,
  action: BidPanelActions
) => {
  switch (action.type) {
    case BidPanelActionEnum.ShowBidPanel: {
      return {
        ...state,
        showBidPanel: true,
        auction: action.state?.auction,
        //fully set up all bids ready to edit
        bids: action.state?.bids,
        originalBids: action.state?.originalBids,
        bidSubmissionResponse: undefined,
        status: '',
        newBlankBid: action.state?.newBlankBid
      };
    }
    case BidPanelActionEnum.HideBidPanel:
      return {
        ...state,
        showBidPanel: false,
        auction: initialBidPanelState.auction,
        bids: [],
        originalBids: [],
        bidSubmissionResponse: undefined,
        status: '',
      };

    case BidPanelActionEnum.HideBidPanelWithNoChanges:
      return {
        ...state,
        showBidPanel: false,
        auction: initialBidPanelState.auction,
        bids: [],
        originalBids: [],
        bidSubmissionResponse: undefined,
        status: '',
      };

    case BidPanelActionEnum.SubmitBid:
      return {
        ...state,
        bids: action.state?.bids,
        loading: true,
      };
    case BidPanelActionEnum.SubmitBidSuccess:
      return {
        ...state,
        bidSubmissionResponse: action.state?.bidSubmissionResponse,
        loading: false,
        status: BidStatus.Accepted,
      };
    case BidPanelActionEnum.SubmitBidFailed:
      return {
        ...state,
        status: action.state?.status,
        loading: false,
      };
    case BidPanelActionEnum.DraftBidFailed:
      return {
        ...state,
        status: action.state?.status,
        loading: false,
      };
    default:
      return state;
  }
};
